import { takeLatest, put, all, call } from "redux-saga/effects";
import { encryptData } from "../../_common/enode-decode";
import {
  diallerPushLogFetchFailure,
  diallerPushLogFetchResponseChanged,
  diallerPushLogFetchSuccess,
} from "./diallerPushLog.action";
import DiallerPushLogTypes from "./diallerPushLog.types";
import { fetchDiallerPushLog } from "./diallerPushLog.services";

/** *********************** SATRT DIALLER PUSH LOG  LIST ************************ */
export function* DiallerePushLogListFetch({ payload }: any) {
  const key: any = "DiallerPushLogKey";
  try {
    // const { Limit } = payload;

    const jsonData: any = {
      Limit: payload.Limit,
      FromDate: payload.FromDate,
      ToDate: payload.ToDate,
      CompanyID: payload.CompanyID,
      InstanceName: payload.InstanceName,
    };
    const fetchData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(fetchDiallerPushLog, fetchData);
    if (responseData.data.statusCode === "100") {
      yield put(diallerPushLogFetchFailure(responseData.data));
    } else {
      yield put(diallerPushLogFetchSuccess(responseData.data));
    }
  } catch (error) {
    yield put(diallerPushLogFetchFailure(error));
  }
}
export function* diallerPushLogFetchReset() {
  yield put(diallerPushLogFetchResponseChanged());
}
export function* onFetchListDiallerPushLog() {
  yield takeLatest(
    DiallerPushLogTypes.DIALLER_PUSH_LOG_FETCH_START,
    DiallerePushLogListFetch,
  );
}
export function* onDiallerPushLogFetchResponseReset() {
  yield takeLatest(
    DiallerPushLogTypes.DIALLER_PUSH_LOG_FETCH_RESET_START,
    diallerPushLogFetchReset,
  );
}

/** *********************** END DIALLER PUSH LOG FETCH LIST ************************ */
export function* diallerPushLogSaga() {
  yield all([
    call(onDiallerPushLogFetchResponseReset),
    call(onFetchListDiallerPushLog),
  ]);
}
